export interface ICharacterData {
	code: number;
	name: string;
	maxHp: number;
	maxSp: number;
	initExtraPoint: number;
	maxExtraPoint: number;
	attackPower: number;
	defense: number;
	criticalChance: number;
	hpRegen: number;
	spRegen: number;
	attackSpeed: number;
	moveSpeed: number;
	sightRange: number;
	radius: number;
	uiHeight: number;
	resource: string;
}
